import React from 'react';
import { Outlet } from 'react-router-dom';

// Thin content shell for Language Lab pages. The section's own navigation
// (Overview, AI Tutor Lab, Vocabulary, Mouth Movements, Practice Lab,
// Writing Lab, Resources) now lives inside the shared global side nav as
// child rows under "Language Lab" (see PRIMARY_ITEM_CHILDREN in
// src/lib/sideNavConfig.js) rather than a standalone sidebar here.
export default function LanguageLabLayout() {
  return (
    <main className="min-w-0 flex-1 px-0">
      <div className="min-h-screen px-4 pb-10 pt-4 sm:px-6 lg:px-8">
        <Outlet />
      </div>
    </main>
  );
}
